<template>
    <div>
        <table class="appointments mt-2">
            <tbody>
                <appointment 
                v-for="appointment of appointments" 
                v-bind:appointment="appointment"
                :key="appointment.key"
                v-on:cancelAppointment="cancelAppointment">
                </appointment>
            </tbody>
        </table>

        <div v-if="isLoading" class="mt-4">
            <div class="loader dark mx-auto"></div>
        </div>

        <div v-else-if="appointments.length === 0" class="text-center mt-4">
            <p>Du har ingen køretimer.</p>
        </div>

        <!-- Mobile -->
        <router-link v-if="!isLoading" :to="{ name: 'appointments/calender' }" class="btn btn-primary btn-block d-block d-sm-none mt-4">Book køretime</router-link>
    </div>
</template>

<script>
import Appointment from '@/components/appointment/Appointment.vue';

export default {
    components: {
        'appointment': Appointment
    },

    data: function() {
        return {
            appointments: [],

            isLoading: true,
        }
    },

    mounted: function() {
        this.fetchAppointments()
    },

    methods: {
        cancelAppointment(appointment) {
            this.axios.post('appointments/'+appointment.id+'/cancel')
                .then(res => {
                    let appointments = this.appointments;
                    let indexOfAppointment = appointments.indexOf(appointment);

                    appointments.splice(indexOfAppointment, 1);

                    this.$notify({
                        group: 'main',
                        type: 'warn',
                        title: 'Bookning slettet!',
                        text: 'Din bookning blev slettet'
                    });
                })
        },

        fetchAppointments() {
            this.axios.get('appointments')
                .then(res => {
                    this.appointments = res.data;
                    this.isLoading = false;
                })
                .catch(error => {
                    console.log(error);
                });
        }
    }
}
</script>
